import { UseMutationResult, useMutation } from 'react-query';

import { localConfig } from '../../../../Configs/localConfig';
import { errorAlert, loadingAlert, successAlert } from '../../../../utils/alert';
import { api } from '../../../api';

//#region Editar Insumo Defensivo
interface PropsPutAdjuvantes {
    cod_insumo_defensivo: number,
    nome: string,
    cod_fabricante: number,
    cod_categoria_produto: number,
    cod_classe_agronomica: number,
    cod_formulacao: number,
    cod_medida_aplicacao: number,
    observacao: string,
    ativos: {
        cod_ativo: number,
        concentracao: number
    }[],
    aplicacoes: {
        cod?: string | number,
        cod_cultura: number,
        cod_fase_cultura: number,
        cultura_nome: string,
        fase_cultura_nome: string,
        alvos: any[]
    }[],
    refetch_data_insumos_defensivos: Function,
    fecharGaveta: Function,
}

export const usePutEditarInsumoDefensivo = (): {
    carregando_editar_insumo_defensivo: boolean
    mutate_editar_insumo_defensivo: (params: PropsPutAdjuvantes) => void
    isSuccess_editar_insumo_defensivo: boolean
} => {
    const mutation: UseMutationResult<Response, Error, PropsPutAdjuvantes> = useMutation(
        async (params: PropsPutAdjuvantes) => {

            const { cod_insumo_defensivo, nome, cod_fabricante, cod_categoria_produto,
                cod_classe_agronomica, cod_formulacao, cod_medida_aplicacao, observacao,
                ativos, aplicacoes, refetch_data_insumos_defensivos, fecharGaveta } = params

            loadingAlert({ msg: 'Salvando...', id: 'editar_insumo_defensivo' })

            return api
                .put(`/recomendacao/insumo-agricola/${cod_insumo_defensivo}?codConta=${localConfig()?.conta}`, {
                    nome,
                    cod_fabricante,
                    cod_categoria_produto,
                    cod_classe_agronomica,
                    cod_formulacao,
                    cod_medida_aplicacao,
                    observacao,
                    ativos,
                    aplicacoes,
                })
                .then((response: any) => {
                    successAlert('Insumo editado com sucesso!', 5000, 'editar_insumo_defensivo')
                    refetch_data_insumos_defensivos?.();
                    fecharGaveta?.();
                    return response
                })
                .catch((error: any) => {
                    if (error?.response?.data?.error[0]?.msg) {
                        error.response.data.error.forEach((data) => {
                            errorAlert(data?.msg[0] ?? 'Falha ao editar insumo!', 5000, 'editar_insumo_defensivo')
                        })

                    } else {
                        errorAlert(
                            error.response.data.error ?? 'Falha ao editar insumo!',
                            5000,
                            'editar_insumo_defensivo'
                        )
                    }

                    throw error
                })

        }
    )

    return {
        carregando_editar_insumo_defensivo: mutation.isLoading,
        mutate_editar_insumo_defensivo: mutation.mutate,
        isSuccess_editar_insumo_defensivo: mutation.isSuccess,
    }
}
//#endregion


//#region Remover ativo da composição
interface PropsRemoverInsumo {
    cod_insumo_defensivo: number,
    ativos_remover: number[],
    atualizarListaAtivosComposicao: Function
    refetch_data_insumos_defensivos: Function
}

export const usePutRemoverInsumoComposicao = (): {
    carregando_remover_ativo: boolean
    mutate_remover_ativo: (params: PropsRemoverInsumo) => void
    isSuccess_remover_ativo: boolean
} => {
    const mutation: UseMutationResult<Response, Error, PropsRemoverInsumo> = useMutation(
        async (params: PropsRemoverInsumo) => {

            const { cod_insumo_defensivo, ativos_remover, atualizarListaAtivosComposicao, refetch_data_insumos_defensivos } = params

            loadingAlert({ msg: 'Removendo ativo...', id: 'remover_ativo' })

            return api
                .put(`/recomendacao/insumo-agricola/${cod_insumo_defensivo}?codConta=${localConfig()?.conta}`, {
                    ativos_remover: ativos_remover,
                })
                .then((response: any) => {
                    successAlert('Ativo removido com sucesso!', 5000, 'remover_ativo')
                    atualizarListaAtivosComposicao?.();
                    refetch_data_insumos_defensivos?.();
                    return response
                })
                .catch((error: any) => {
                    if (error?.response?.data?.error[0]?.msg) {
                        error.response.data.error.forEach((data) => {
                            errorAlert(data?.msg[0] ?? 'Falha ao remover ativo!', 5000, 'remover_ativo')
                        })

                    } else {
                        errorAlert(
                            error.response.data.error ?? 'Falha ao remover ativo!',
                            5000,
                            'remover_ativo'
                        )
                    }

                    throw error
                })

        }
    )

    return {
        carregando_remover_ativo: mutation.isLoading,
        mutate_remover_ativo: mutation.mutate,
        isSuccess_remover_ativo: mutation.isSuccess,
    }
}
//#endregion